module.exports = __webpack_public_path__ + "static/media/user-icon.451f60da.svg";